// extracted by mini-css-extract-plugin
export default {"root":"styles_root__R0ESc","label":"styles_label__KfHGR","disabled":"styles_disabled__hl0z8"};